// @flow

import { graphql } from 'react-relay';
import { Box, useSystem } from 'react-system';
// $FlowFixMe[untyped-import]
import Alert from '@material-ui/lab/Alert';
import { PageMeta } from '../shared/prismic/PageMeta';
import { LoginContextual } from '../shared/login/index';
import { useLocale } from '../hooks/locale.js';
import { useRouter } from '../controls/router';
import { Marked } from '../controls/marked.js';
import { type NextQuery, nextQuery } from '../controls/relay';
import { MuiThemeProvider } from '../controls/mui-providers';
import { Layout } from '../shared/Layout';
import type { loginQuery } from './__generated__/loginQuery.graphql.js';

const LoginError = () => {
  const { t } = useLocale();
  const router = useRouter();
  const error = router.query.error;
  if (error == null) {
    return null;
  }
  let message = t('somethingWentWrong');
  if (error === 'EXPIRED_CODE') {
    message = t('authEmailExpired');
  }
  if (error === 'EXPIRED_TOKEN') {
    message = t('authMagicTokenExpired');
  }
  return (
    <Alert
      severity="error"
      css={{
        marginBottom: 8,
        '.MuiAlert-icon': { display: 'none' },
        p: { margin: 0 },
      }}
    >
      <Marked>{message}</Marked>
    </Alert>
  );
};

const Login = props => {
  const { media } = useSystem();
  const { t } = useLocale();
  const router = useRouter();
  const returnUri = router.getUrl(
    router.query.return != null ? router.query.return : '/',
  ).relative;
  return (
    <Layout
      root={props.data}
      headerStyle="normal"
      pageWithData={props.data.cms.pageWithData}
    >
      <MuiThemeProvider>
        <Box mx="auto" px={3} pb={5} css={media({ width: ['100%', 360] })}>
          <PageMeta root={props.data} />
          <h1 css={{ textAlign: 'center' }}>{t('signInOrRegister')}</h1>
          <LoginError />
          <LoginContextual
            privacyAgreement={null}
            communicationOptIn={null}
            returnHref={returnUri}
          />
        </Box>
      </MuiThemeProvider>
    </Layout>
  );
};

const LoginPage: NextQuery<loginQuery, {| lang?: string, uid?: string |}> =
  nextQuery(ctx => ({
    query: graphql`
      query loginQuery($uid: String!, $lang: String!) {
        ...Layout_root @arguments(lang: $lang)
        ...PageMeta_root
        cms {
          pageWithData(uid: $uid, lang: $lang) {
            ...Layout_pageWithData
          }
        }
      }
    `,
    variables: {
      uid: ctx.query.uid ?? '',
      lang: ctx.query.lang ?? '',
    },
  }))(Login);

export default LoginPage;
